import { ThermostatStatus } from '@/../client-generator/generated-clients/plants';
import { Options } from 'vue-class-component';
import SceneActionGeneral from '../SceneActionGeneral';
import EnumToSelectButton from '@/views/components/EnumToSelectButton/EnumToSelectButton.vue';

@Options({
  name: 'ActionThermostat',
  components: {
    EnumToSelectButton,
  },
})
export default class ActionThermostat extends SceneActionGeneral {
  ThermostatStatus = ThermostatStatus;

  get isConfirmEnabled() {
    return true;
  }
}
